export default "__VITE_ASSET__BI$FPxaQ__"